import { GridsterItem } from "angular-gridster2";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { MarketNewsComponent } from "./../components/market-news/market-news.component";
import { OrderBookComponent } from "./../components/order-book/order-book.component";
import { MarketTradesComponent } from "./../components/market-trades/market-trades.component";
import { MarketDepthComponent } from "./../components/market-depth/market-depth.component";
import { MarketDepthBidsComponent } from "./../components/market-depth-bids/market-depth-bids.component";
import { MarketDepthAsksComponent } from "./../components/market-depth-asks/market-depth-asks.component";
import { TradesComponent } from "./../components/trades/trades.component";
import { NewsComponent } from "./../components/news/news.component";
import { HistoricalComponent } from "./../components/historical/historical.component";
//import { OrderReviewComponent } from "./../components/order-review/order-review.component";
import { DetailedQuotaComponent } from "../screens/detailed-quota/detailed-quota.component";
import { SlickMarketWatchComponent } from "./../components/slick-market-watch/slick-market-watch.component";
import { BehaviorSubject } from 'rxjs';
import { IdService } from '../services/contentId.service';
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CustomContentPane } from "../screens/test/custom-content-pane.interface";
import { DeviceDetectorService } from "./DeviceDetectorService";
import {
  IgcContentPane,
  IgcDockManagerComponent,
  IgcDockManagerLayout,
  IgcDockManagerPaneType,
  IgcPaneCloseEventArgs,
  IgcSplitPane,
  IgcSplitPaneOrientation,
  IgcTabGroupPane,
  IgcDockManagerPane
} from "docking-egid";

@Injectable({
  providedIn: "root",
})
//________________________________________________________________________________________________________________________________________________
//This service handles most of the logic retaining to the test/home component
//________________________________________________________________________________________________________________________________________________

//The paneAddedSubject is responsible for emmiting an update to the test/home component once a new pane is added (through add generic from nav bar component 
//or from the contextmenu/button in the slick-market-watch component)
//The contentIdMap is responsible for linking each pane to a contentId accross all layouts and maintain intergity of the data
export class FlexLayoutService {
  private paneAddedSubject = new Subject<{ id: string, header: string, component: any, headerId: string, isLinked: boolean }>();
  paneAdded$ = this.paneAddedSubject.asObservable();
  public contentIdMap: Record<string, string> = {};
  contentIdIsLinkedMap: { [key: string]: boolean } = {};
  private panes: any[] = [];
  dashboardIndex;
  isResetting: boolean = false;




// This is the inital default layout, we create a IgcDockManagerLayout which holds a root pane and floating panes 
  public defaultDash: IgcDockManagerLayout = {
    rootPane: {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.vertical,
      panes: this.initializePanes(), // Use the method to initialize panes
    },
    floatingPanes: [],
  };

//This is the default layout lists
  public defaultDashList: IgcDockManagerLayout[] = [this.defaultDash];
  checkAndSetDefaultLayout() {
    let checkLocal = localStorage.getItem("dashboardLayoutLists");

    // Check if 'dashboardLayoutLists' does not exist or is an empty string
    if (!checkLocal || checkLocal.length === 0) {
      // Use the defaultDash from the service and store it in localStorage
      localStorage.setItem('dashboardLayoutLists', JSON.stringify(this.defaultDashList));
    }
  }
//Helper function to create a default CusotmContentPane
  private createCustomContentPane(header: string, headerId: string, params: any): CustomContentPane {
    return {
      type: IgcDockManagerPaneType.contentPane,
      contentId: this.idService.generateId('content'),
      header: header,
      headerId: headerId,
      ...params,
      symbolCode: params.symbolCode || '',
      reuters: params.reuters || '',
      isLinked: params.isLinked || false,
      companyName: params.companyName || '',
      state: params.state || 'Most Active',
      Id: params.Id || 0
    };
  }

  // private initializePanes() {
  //   const panes: IgcDockManagerPane[] = [
  //     {
  //       type: IgcDockManagerPaneType.splitPane,
  //       orientation: IgcSplitPaneOrientation.horizontal,
  //       panes: [
  //         this.createCustomContentPane('Market', 'market-watch', { isLinked: true ,state:"Most Active"}),
  //         this.createCustomContentPane('Market Trades', 'market-trades', { isLinked: true }),
  //         this.createCustomContentPane('Market News', 'market-news', { isLinked: true }),
  //       ],
  //     },
  //     {
  //       type: IgcDockManagerPaneType.splitPane,
  //       orientation: IgcSplitPaneOrientation.horizontal,
  //       panes: [

  //         this.createCustomContentPane('Buy Order Book', 'order-book', { isLinked: true }),
  //         this.createCustomContentPane('Market Depth', 'market-depth', { isLinked: true }),
  //         this.createCustomContentPane('Historical', 'historical', { isLinked: true }),
          
  //       ],
  //     },
  //   ];

  //   // Populate the floating pane map with the original data
  //   this.storeContentIdMap(panes);
  //   localStorage.setItem('idCounter', "0");
  //   localStorage.setItem('defaultPaneCount', "6");
  //   return panes;
  // }
  private initializePanes() {
const deviceType = this.deviceService.getDeviceType();

let panes: IgcDockManagerPane[];

if (deviceType === 'desktop') {
  panes = [
    {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      panes: [
        this.createCustomContentPane(this.translate.instant("Market"), 'market-watch', { isLinked: true, state: "Most Active" }),
        this.createCustomContentPane(this.translate.instant("market-trades"), 'market-trades', { isLinked: true }),
        this.createCustomContentPane(this.translate.instant("market-news"), 'market-news', { isLinked: true }),
      ],
    },
    {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      panes: [
          this.createCustomContentPane('Buy Order Book', 'order-book', { isLinked: true }),
          this.createCustomContentPane('Market Depth', 'market-depth', { isLinked: true }),
          this.createCustomContentPane('Historical', 'historical', { isLinked: true }),
      ],
    },
  ];
} else if (deviceType === 'mobile') {
  panes = [
    {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      panes: [
        this.createCustomContentPane(this.translate.instant("Market"), 'market-watch', { isLinked: true, state: "Most Active" }),

      ],
    },
    {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      panes: [
        this.createCustomContentPane('Market Depth', 'market-depth', { isLinked: true }),

      ],
    },
  ];
}
else  {
  panes = [
    {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      panes: [
        this.createCustomContentPane(this.translate.instant("Market"), 'market-watch', { isLinked: true, state: "Most Active" }),
      ],
    },
    {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      panes: [
          this.createCustomContentPane('Market Depth', 'market-depth', { isLinked: true }),
          this.createCustomContentPane('Historical', 'historical', { isLinked: true }),

      ],
    },
  ];
}

    
    // Populate the floating pane map with the original data
    this.storeContentIdMap(panes);
    localStorage.setItem('idCounter', "0");
    if (deviceType === 'mobile' || deviceType === 'tablet') {
      localStorage.setItem('defaultPaneCount', "2");
      } else {
    localStorage.setItem('defaultPaneCount', "6");
      }
    return panes;
  }

  private storeContentIdMap(panes: IgcDockManagerPane[]): void {
    panes.forEach(pane => {
      if (pane.type === IgcDockManagerPaneType.splitPane && (pane as IgcSplitPane).panes) {
        this.storeContentIdMap((pane as IgcSplitPane).panes);
      } else if (pane.type === IgcDockManagerPaneType.contentPane) {
        this.contentIdMap[(pane as IgcContentPane).contentId] = 'content' + (Object.keys(this.contentIdMap).length + 1);

      }
    });
  }
  public getSlotByContentId(contentId: string): string {
    return this.contentIdMap[contentId];
  }
  public getIsLinkedForPane(contentId: string): boolean {
    return this.contentIdIsLinkedMap[contentId];
  }

//This subject is responsible for emitting layout changes
  private layoutSubject = new BehaviorSubject<IgcDockManagerLayout>(this.defaultDash);
  layout$ = this.layoutSubject.asObservable();

  constructor(private idService: IdService,
    public translate: TranslateService,
    private toastr: ToastrService,
    private deviceService: DeviceDetectorService

  ) {
    this.initTheme();
  }

  private newGenericWidget = new Subject<any>();

  isDarkTheme: boolean;

//This is the add a new pane function, all new panes will be floating and this function is responsible for passing them the necessary company and pane data
  addGeneric(name: string, isLinked: boolean) {
    let component;
    let id;
    let headerId;
    switch (name) {
      case "market-watch":
        component = SlickMarketWatchComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "market-watch";
        isLinked;
        break;
      case "news":
        component = NewsComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "news";
        isLinked;
        break;
      case "trades":
        component = TradesComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "trades";
        isLinked;
        break;
      case "depth-asks":
        component = MarketDepthAsksComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "depth-asks";
        isLinked;
        break;
      case "depth-bids":
        component = MarketDepthBidsComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "depth-bids";
        isLinked;
        break;
      case "market-depth":
        component = MarketDepthComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "market-depth";
        isLinked;
        break;
      case "market-trades":
        component = MarketTradesComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "market-trades";
        isLinked;
        break;
      case "historical":
        component = HistoricalComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "historical";
        isLinked;
        break;
      case "bids":
        component = MarketDepthBidsComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "bids";
        isLinked;
        break;
      case "asks":
        component = MarketDepthAsksComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "asks";
        isLinked;
        break;
      case "order-book":
        component = OrderBookComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "order-book";
        isLinked;
        break;
      case "market-news":
        component = MarketNewsComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "market-news";
        isLinked;
        break;
    //   case "order-review":
    //     component = OrderReviewComponent;
    //     id = this.idService.generateFloatingId('content');
    //     headerId = "order-review";
    //     isLinked;
    //     break;
      case "detailed-quota":
        component = DetailedQuotaComponent;
        id = this.idService.generateFloatingId('content');
        headerId = "detailed-quota";
        isLinked;
        break;
    }

    if (component) {
      const header = name.replace(/-/g, ' ').toUpperCase();
      const existingRootPanes = this.getAllPanes(this.defaultDash.rootPane);
      const existingFloatingPanes = this.getAllFloatingPanes(this.defaultDash.floatingPanes);

      const allPanes = [...existingRootPanes, ...existingFloatingPanes];
//Checking for duplicate panes by looking for the same headerId, the link of the pane found and the link of the newly added pane
      const duplicatePane = allPanes.find(pane => pane.headerId === headerId && pane.isLinked === true && pane.isLinked === isLinked);
      if (duplicatePane) {
        this.idService.revertLastGeneratedFloatingId();
        this.toastr.error("", this.translate.instant("linked-already-exist"), {
          timeOut: 15000,
          positionClass: "toast-bottom-center",
          closeButton: true,
        });
      } else {
        this.addPane(id, header, component, headerId, isLinked);
      }
    }
  }

  private addPane(id: string, header: string, component: any, headerId: string, isLinked: boolean) {
    const newPane = { id, header, component, headerId, isLinked };
    this.contentIdMap[id] = 'content' + (Object.keys(this.contentIdMap).length + 1);
    this.contentIdIsLinkedMap[id] = isLinked;
    localStorage.setItem('Map', JSON.stringify(this.contentIdMap));
    this.paneAddedSubject.next(newPane);
  }

//Retains the company data within the layout itself (not only the dynamic component), essential to reatain the data upon switching dashboards or refreshing
  setPaneCompanyData(contentId: string, symbolCode: string, reuters: string, companyName: string, wasChanged: boolean,state :string) {
    // Get all the content panes from root and floating panes
    const existingRootPanes = this.getAllPanes(this.defaultDash.rootPane);
    const existingFloatingPanes = this.defaultDash.floatingPanes
      ? this.getAllFloatingPanes(this.defaultDash.floatingPanes)
      : [];

    const allPanes = [...existingRootPanes, ...existingFloatingPanes];

    // Find the exact pane using contentId
    const exactPane = allPanes.find(pane => pane.contentId === contentId);

    if (exactPane) {
      // Update the properties of the found pane
      exactPane.companyName = companyName;
      exactPane.reuters = reuters;
      exactPane.symbolCode = symbolCode;
      exactPane.wasChanged = wasChanged;
      exactPane.state = state;

      // Now find the exact pane in the `defaultDash` to apply the changes
      this.updatePaneInDefaultDash(exactPane,this.dashboardIndex);
    } 
  }

  // Function to update the exact pane in `defaultDash`
  private updatePaneInDefaultDash(updatedPane: CustomContentPane,index:number) {
    
    // Update the pane in the rootPane
    const updatePanesRecursive = (pane: IgcDockManagerPane): boolean => {
      if (pane.type === IgcDockManagerPaneType.contentPane && pane.contentId === updatedPane.contentId) {
        Object.assign(pane, updatedPane);
        //localStorage.setItem("dashboardLayout", JSON.stringify(this.defaultDash));
        if(this.dashboardIndex != null)
        this.saveLayout(this.defaultDash, this.dashboardIndex);
        // Update the pane directly
        return true;
      }

      if (pane.type === IgcDockManagerPaneType.splitPane || pane.type === IgcDockManagerPaneType.tabGroupPane) {
        const compositePane = pane as IgcSplitPane | IgcTabGroupPane;
        return compositePane.panes.some(childPane => updatePanesRecursive(childPane));
      }

      return false;
    };

    // Update rootPane
    const rootPaneUpdated = updatePanesRecursive(this.defaultDash.rootPane);

    // Update floatingPanes if necessary
    if (!rootPaneUpdated && this.defaultDash.floatingPanes) {
      this.defaultDash.floatingPanes.forEach((floatingPane: IgcDockManagerPane) => updatePanesRecursive(floatingPane));
    }

  }

//Iterate over all docked content panes in the root of the layout and return them
  getAllPanes(rootPane: IgcDockManagerPane): CustomContentPane[] {
    const contentPanes: CustomContentPane[] = [];
    const stack: IgcDockManagerPane[] = [rootPane];

    while (stack.length > 0) {
      const currentPane = stack.pop();

      if (currentPane) {
        if (currentPane.type === IgcDockManagerPaneType.splitPane) {
          const splitPane = currentPane as IgcSplitPane;
          if (splitPane.panes && Array.isArray(splitPane.panes)) {
            stack.push(...splitPane.panes.filter(pane => pane !== undefined));
          }
        }
        else if (currentPane.type === IgcDockManagerPaneType.tabGroupPane) {
          const tabGroupPane = currentPane as IgcTabGroupPane;
          if (tabGroupPane.panes && Array.isArray(tabGroupPane.panes)) {
            stack.push(...tabGroupPane.panes.filter(pane => pane !== undefined));
          }
        }
        else if (currentPane.type === IgcDockManagerPaneType.contentPane) {
          contentPanes.push(currentPane as CustomContentPane);
        }
      }
    }

    return contentPanes;
  }


//Iterate over all floating content panes of the layout and return them
  getAllFloatingPanes(floatingPanes: IgcDockManagerPane[]): CustomContentPane[] {
    const contentPanes: CustomContentPane[] = [];
    const stack: IgcDockManagerPane[] = [...floatingPanes]; // Start with all floating panes

    while (stack.length > 0) {
      const currentPane = stack.pop();

      if (currentPane) {
        if (currentPane.type === IgcDockManagerPaneType.splitPane) {
          const splitPane = currentPane as IgcSplitPane;
          if (splitPane.panes && Array.isArray(splitPane.panes)) {
            stack.push(...splitPane.panes.filter(pane => pane !== undefined));
          }
        }
        else if (currentPane.type === IgcDockManagerPaneType.tabGroupPane) {
          const tabGroupPane = currentPane as IgcTabGroupPane;
          if (tabGroupPane.panes && Array.isArray(tabGroupPane.panes)) {
            stack.push(...tabGroupPane.panes.filter(pane => pane !== undefined));
          }
        }
        else if (currentPane.type === IgcDockManagerPaneType.contentPane) {
          contentPanes.push(currentPane as CustomContentPane);
        }
      }
    }

    return contentPanes;
  }

//Make sure the there is always a pane left to maintain the docking layout  
  checkSplitAndTabGroupPanes(panes: IgcDockManagerPane[]): boolean {
    let hasSplitPane = false;
    let tabGroupPaneCount = 0;
    let firstItemProcessed = false;

    const stack: IgcDockManagerPane[] = [...panes];

    while (stack.length > 0) {
      const currentPane = stack.pop();

      if (currentPane) {
        // Check if the first pane is a split pane
        if (!firstItemProcessed && currentPane.type === IgcDockManagerPaneType.splitPane) {
          firstItemProcessed = true;
          const splitPane = currentPane as IgcSplitPane;

          if (splitPane.panes && Array.isArray(splitPane.panes) && splitPane.panes.length === 1) {
            // If the split pane contains only one pane and that pane is a TabGroupPane, continue logic with it
            const firstPane = splitPane.panes[0];
            if (firstPane.type === IgcDockManagerPaneType.tabGroupPane) {
              tabGroupPaneCount++; // Count this TabGroupPane
              const tabGroupPane = firstPane as IgcTabGroupPane;
              if (tabGroupPane.panes && Array.isArray(tabGroupPane.panes)) {
                stack.push(...tabGroupPane.panes.filter(pane => pane !== undefined));
              }
            }
          }
          // If it contains more than one pane, continue checking other panes as usual
          else if (splitPane.panes && Array.isArray(splitPane.panes)) {
            stack.push(...splitPane.panes.filter(pane => pane !== undefined));
          }
        } else {
          // Process non-first panes as usual
          if (currentPane.type === IgcDockManagerPaneType.splitPane) {
            hasSplitPane = true; // Mark that a split pane was found
            const splitPane = currentPane as IgcSplitPane;
            if (splitPane.panes && Array.isArray(splitPane.panes)) {
              stack.push(...splitPane.panes.filter(pane => pane !== undefined));
            }
          } else if (currentPane.type === IgcDockManagerPaneType.tabGroupPane) {
            tabGroupPaneCount++; // Found a tab group pane
            const tabGroupPane = currentPane as IgcTabGroupPane;
            if (tabGroupPane.panes && Array.isArray(tabGroupPane.panes)) {
              stack.push(...tabGroupPane.panes.filter(pane => pane !== undefined));
            }
          }
        }
      }
    }

    // Return true if there are no split panes and exactly one tab group pane
    return !hasSplitPane && tabGroupPaneCount === 1;
  }

  saveGrid(newLayout: IgcDockManagerLayout) {
    localStorage.setItem("dashboardLayoutLists", JSON.stringify(newLayout));
  }

   resetGrid() {
    const dashboardIndex = localStorage.getItem('dashboardindex');
    // Parse the stored layout lists
    const dashboardLayoutLists = JSON.parse(localStorage.getItem('dashboardLayoutLists') || '[]');
    // Convert dashboardIndex to a number
    const index = dashboardIndex ? parseInt(dashboardIndex, 10) : 0;    // Default content ID Map
    const defaultLayout: IgcDockManagerLayout[] = this.defaultDashList;
    const map = {
      "content1": "content1",
      "content2": "content2",
      "content3": "content3",
      "content4": "content4",
      "content5": "content5",
      "content6": "content6"
    };
        // Validate the index is within bounds
    if (index >= 0 && index < dashboardLayoutLists.length) {
        // Update the layout at the selected index
        dashboardLayoutLists[index] = defaultLayout[0];
        
        // Save the updated layouts back to localStorage
        localStorage.setItem('dashboardLayoutLists', JSON.stringify(dashboardLayoutLists));
    } else {
        console.warn(`Invalid dashboard index: ${index}`);
    }
    // localStorage.setItem("dashboardLayoutLists", JSON.stringify(defaultLayout[0]));
    localStorage.setItem("dashboardLayout", JSON.stringify(defaultLayout[0]));
    localStorage.setItem("Map", JSON.stringify(map));
    localStorage.setItem('idCounter', "0");
    localStorage.setItem('defaultPaneCount', "6");
    localStorage.setItem('dashboardindex', "0");

    this.isResetting = true;

  }


  updateGridWithIndex(index: number, newFloatingPane: IgcSplitPane) {
    // Retrieve the current layout
    const currentLayout: IgcDockManagerLayout = this.getGrid();

    // Ensure the floatingPanes array exists
    if (!currentLayout.floatingPanes) {
      currentLayout.floatingPanes = [];
    }

    // Add the new floating pane to the floatingPanes array
    currentLayout.floatingPanes.push(newFloatingPane);

    // Save the updated layout back to local storage
    localStorage.setItem("dashboardLayoutLists", JSON.stringify(currentLayout));
  }


  onNewGenericAdded(): Observable<any> {
    return this.newGenericWidget.asObservable();
  }

  getGrid() {
    const gridData = localStorage.getItem('dashboardLayoutLists');
    return gridData ? JSON.parse(gridData) : []; // Return empty array if null
  }

  saveLayout(layout: IgcDockManagerLayout, dashboardIndex: number): void {
    // Retrieve the current list of layouts from localStorage
    const layoutLists = JSON.parse(localStorage.getItem('dashboardLayoutLists') || '[]');

    // Update the layout at the given index if it exists, otherwise add it
    if (dashboardIndex >= 0 && dashboardIndex < layoutLists.length) {
      layoutLists[dashboardIndex] = layout;  // Update the existing layout at the index
    } else {
      layoutLists.push(layout);  // Add a new layout if the index is out of bounds
    }

    // Save the updated layout and layout list back to localStorage
    localStorage.setItem('dashboardLayout', JSON.stringify(layout));  // Optional: If you want to store the current layout separately
    localStorage.setItem('dashboardLayoutLists', JSON.stringify(layoutLists));
  }
  saveLayoutList(layout: IgcDockManagerLayout[]): void {
    localStorage.setItem('dashboardLayoutLists', JSON.stringify(layout));
  }

  loadLayout(): IgcDockManagerLayout | null {
    const layout = localStorage.getItem('dashboardLayout');
    return layout ? JSON.parse(layout) : null;
  }

  loadNewLayout(index: number): IgcDockManagerLayout | null {
    const newLayout = localStorage.getItem('dashboardLayoutLists');

    if (newLayout) {
      const layoutLists = JSON.parse(newLayout);
      const layout = layoutLists[index];
      return layout ? layout : null;
    }

    return null;
  }
  updateLayout(newLayout: IgcDockManagerLayout, index) {
    this.dashboardIndex = index;
    this.layoutSubject.next(newLayout);
    // this.defaultDash=newLayout;
    this.saveLayout(newLayout, index); // Save the updated layout
  }

  addNewDashboard(): number {
    const currentLayout: IgcDockManagerLayout[] = this.getGrid();
    const newLayout: IgcDockManagerLayout = this.layoutSubject.getValue();

    currentLayout.push(newLayout);
    this.saveLayoutList(currentLayout);

    return currentLayout.length;
  }
  removeDashboard(index: number) {
    const tempLayout = this.getGrid();
    tempLayout.splice(index, 1);
    localStorage.setItem("dashboardLayoutLists", JSON.stringify(tempLayout));
    return tempLayout.length;
  }


  saveLang(language) {
    localStorage.setItem("lang", language);
  }

  getLang() {
    return localStorage.getItem("lang");
  }

  saveMarketWatchColumns(newColsList) {
    localStorage.setItem("marketCols", JSON.stringify(newColsList));
  }

  getMarketWatchColumns() {
    return JSON.parse(localStorage.getItem("marketCols"));
  }

  savePortfolioColumns(newColsList) {
    localStorage.setItem("portfolioCols", JSON.stringify(newColsList));
  }

  getPortfolioColumns() {
    return JSON.parse(localStorage.getItem("portfolioCols"));
  }

  updateMarketWatchState(newState) {
    const existingRootPanes = this.getAllPanes(this.defaultDash.rootPane);
    const existingFloatingPanes = this.defaultDash.floatingPanes
      ? this.getAllFloatingPanes(this.defaultDash.floatingPanes)
      : [];

    const allPanes = [...existingRootPanes, ...existingFloatingPanes];

    // Find the exact pane using contentId
    const exactPane = allPanes.find(pane => pane.headerId === "market-watch");

    exactPane.state=newState;
    this.updatePaneInDefaultDash(exactPane,this.dashboardIndex);
  }


  /////////////
  saveOrderHistoryColumns(newColsList) {
    localStorage.setItem("orderHistoryCols", JSON.stringify(newColsList));
  }

  getOrderHistoryColumns() {
    return JSON.parse(localStorage.getItem("orderHistoryCols"));
  }
  //////////////
  saveTradeHistoryColumns(newColsList) {
    localStorage.setItem("tradeHistoryCols", JSON.stringify(newColsList));
  }

  getTradeHistoryColumns() {
    return JSON.parse(localStorage.getItem("tradeHistoryCols"));
  }

  switchTheme() {
    this.isDarkTheme = !this.isDarkTheme;
  }

  initTheme() {
    this.isDarkTheme =
    localStorage.getItem("darktheme") == "light" ? false : true;
    localStorage.setItem("darktheme", this.isDarkTheme ? "dark" : "light");
    document.body.setAttribute(
      "data-theme",
      this.isDarkTheme ? "dark" : "light"
    );
  }
}